import { useCallback } from "react";

import { useLocation } from "react-router-dom";

import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import {
  MeetingReportTab,
  MeetingReportNudge,
} from "@app/analytics/MeetingReport/types";

const shouldShowNudge = (pathname: string, nudgeTab?: MeetingReportTab) => {
  if (!nudgeTab) return false;

  if (nudgeTab === "recap") {
    return !pathname.includes("deep-dive") && !pathname.includes("coaching");
  }

  return pathname.includes(nudgeTab);
};

const useNudge = (
  type: "main" | "sidebar"
): [MeetingReportNudge | null, (nudge: MeetingReportNudge | null) => void] => {
  const location = useLocation();

  const [nudge, setNudge] = useMeetingReportUiStore((state) => [
    state[type].nudge,
    state.setNudge,
  ]);

  const curriedSetNudge = useCallback(
    (nudge: MeetingReportNudge | null) => setNudge(type, nudge),
    [type]
  );

  const nudgeToShow = shouldShowNudge(location.pathname, nudge?.tab)
    ? nudge
    : null;

  return [nudgeToShow, curriedSetNudge];
};

export default useNudge;
